import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import callrecorderUrls from "../../configs/callrecorder/callrecorderUrls";
import { SubscriptionInterface } from '../../store/callrecorder/subscriptionsSlice';

const PREFIX = 'callrecorder';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: callrecorderUrls.subscriptionPath(value.id)
  };
}

export const subscriptionsEntity = new schema.Entity(
  'subscriptions',
  {},
  {
    processStrategy
  }
);

export const subscriptionEntity = new schema.Entity(
  'subscription',
  {},
  {
    processStrategy
  }
);

const fetchSubscriptionsCollection = async (url: string, params: object = {}) => {
  const response = await callrecorderApi.get(url, { params })
  const normalized = normalize<
    any,
    {
      subscriptions: { [key: string]: SubscriptionInterface };
    }
  >(response.data.subscriptions, [subscriptionsEntity]);

  return {
    subscriptions: normalized.entities?.subscriptions || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { subscription: SubscriptionInterface; }
  >(response.data.subscription, subscriptionEntity);
  return normalized.entities;
}

export const fetchSubscriptions = createAsyncThunk(
  `${PREFIX}_subscriptions/fetchSubscriptions`,
  async (params: object = {}) => fetchSubscriptionsCollection('/onesky/subscriptions', params)
);

export const fetchSubscription = createAsyncThunk(
  `${PREFIX}_subscriptions/fetchSubscription`,
  async (id: number | string) => {
    const response = await callrecorderApi.get(`/onesky/subscriptions/${id}`);
    return normalizeInstance(response);
  }
);
